import { EmployeeTransferPage } from "@/features/employeeTransfer/pages/EmployeeTransferPage";
import type { RouteConfig } from "@/router/types";

export const EMPLOYEE_TRANSFER_PATH = "/transfert/:token";

const employeeTransferRoutes: RouteConfig[] = [
  {
    path: EMPLOYEE_TRANSFER_PATH,
    element: <EmployeeTransferPage />,
    isProtected: false,
    useMainLayout: false,
  },
];

export default employeeTransferRoutes;
